import React from "react";
import "./banner-inner.scss";
import { StaticImage } from "gatsby-plugin-image";
import AOS from "aos";
import "aos/dist/aos.css";

const BannerInner = (props) => {

  React.useEffect(() => {
    AOS.init({
      offset: 50,
      duration: 1000,
      easing: "ease",
    });

    AOS.refresh();
    setTimeout(function () {
      AOS.init();
    }, 1000);
  }, []);
  return (
    <div
      className="banner-inner"
      style={{ background: `url(${props.bannerBg})` }}
    >
      <StaticImage
        className="bottom-curve"
        src="../../../images/white-curve.png"
        alt="White Curve Shape"
        placeholder="none"
        quality={100}
      />
      {/* <img src={whiteCurve} alt="" className='bottom-curve'/> */}
      <div className="centered-content">
        <div className="banner-inner__content" data-aos="fade-up">
          {props.pageTitle && <h3>{props.pageTitle}</h3>}
          {props.children && props.children}
        </div>
      </div>
    </div>
  );
};

export default BannerInner;
